import locales from './locales.json';
import DEFAULT_TRANSLATION from './en.json';
const DEFAULT_CODE = 'en';

declare global {
  export type Translation = typeof DEFAULT_TRANSLATION;
  export type TranslationId = keyof Translation;
}

let translation_cache: { [key: string]: Translation };
/**
 * Loads all translation w fallback
 * @example `pt-BT` will fallback to `pt` which will fallback to default `en`
 */
export const loadAllTranslations = () => {
  if (translation_cache) {
    return translation_cache;
  }

  const translations = locales
    .filter((l) => l.code !== DEFAULT_CODE)
    .reduce(
      (agg, loco) => {
        const t = require(`./${loco.code}.json`);
        agg[loco.code] = t;
        return agg;
      },
      { en: DEFAULT_TRANSLATION } as { [key: string]: Translation }
    );

  Object.entries(translations)
    .filter(([code]) => code !== DEFAULT_CODE)
    .forEach(([code, t]) => {
      if (code.indexOf('-')) {
        const baseCode = code.split('-')[0];
        if (translations[baseCode]) {
          translations[code] = { ...DEFAULT_TRANSLATION, ...translations[baseCode], ...t };
        }
      } else {
        translations[code] = { ...DEFAULT_TRANSLATION, ...t };
      }
    });

  translation_cache = translations;

  return translations;
};

export const getTranslationOrDefault = (code: string): [string, Translation] => {
  const translations = loadAllTranslations();
  if (translations[code]) {
    return [code, translations[code]];
  }

  if (code.indexOf('-')) {
    const baseCode = code.split('-')[0];
    if (translations[baseCode]) {
      return [baseCode, translations[baseCode]];
    }
  }
  return [DEFAULT_CODE, translations[DEFAULT_CODE]];
};
